export default "__VITE_ASSET__CZUzHCtb__"